
// // export default PendingRequests;
// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   Box,
//   Typography,
//   IconButton,
//   CircularProgress,
//   Tooltip,
//   Paper,
//   Divider,
//   Button,
//   Card,
//   CardContent,
//   Avatar,
//   Stack,
//   Chip,
//   alpha,
//   Drawer,
//   useTheme,
//   useMediaQuery,
// } from "@mui/material";
// import { ArrowBack, ArrowForward, Delete, Close } from "@mui/icons-material";
// import GroupIcon from "@mui/icons-material/Group";
// import HomeIcon from "@mui/icons-material/Home";
// import SendIcon from "@mui/icons-material/Send";
// import AccessTimeIcon from "@mui/icons-material/AccessTime";
// import axios from "axios";
// import TopBar from "../globalComponents/topbar";
// import Footer from "../globalComponents/footer";

// const PendingRequests = () => {
//   const [requests, setRequests]               = useState([]);
//   const [mentorsMap, setMentorsMap]           = useState({});
//   const [loadingRequests, setLoadingRequests] = useState(false);
//   const [loadingMentors, setLoadingMentors]   = useState(false);
//   const [error, setError]                     = useState("");
//   const [currentPage, setCurrentPage]         = useState(1);
//   const [selectedRequest, setSelectedRequest] = useState(null);
//   // On mobile we show the detail panel inside a bottom drawer
//   const [drawerOpen, setDrawerOpen]           = useState(false);

//   const navigate = useNavigate();
//   const theme    = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md")); // < 900px

//   const requestsPerPage = 4;
//   const API_BASE        = "https://backend-global-1vq9.onrender.com";

//   // ── Fetch mentors ──────────────────────────────────────────────
//   useEffect(() => {
//     (async () => {
//       try {
//         setLoadingMentors(true);
//         const res     = await axios.get(`${API_BASE}/api/mentor/list`);
//         const mentors = res.data?.mentors || [];
//         const map     = {};
//         for (const m of mentors) {
//           const idKey = typeof m.userId === "object" ? m.userId._id || "" : m.userId;
//           if (idKey) map[idKey] = m;
//         }
//         setMentorsMap(map);
//       } catch (err) {
//         console.error("Error fetching mentors:", err);
//       } finally {
//         setLoadingMentors(false);
//       }
//     })();
//   }, []);

//   // ── Fetch requests ─────────────────────────────────────────────
//   useEffect(() => {
//     (async () => {
//       try {
//         setLoadingRequests(true);
//         const user   = JSON.parse(localStorage.getItem("user"));
//         const userId = user?.id || user?._id;

//         if (!userId) { setError("User not logged in"); return; }

//         const res             = await axios.get(`${API_BASE}/api/connection-requests/mentee/${userId}`);
//         const fetchedRequests = res.data?.data || [];
//         setRequests(fetchedRequests);

//         if (fetchedRequests.length > 0) {
//           setSelectedRequest(fetchedRequests[0]);
//           setCurrentPage(1);
//         } else {
//           setSelectedRequest(null);
//         }
//       } catch (err) {
//         console.error("Error fetching mentee requests:", err);
//         setError("Failed to fetch connection requests.");
//       } finally {
//         setLoadingRequests(false);
//       }
//     })();
//   }, []);

//   const getMentorById = (mentorId) => {
//     if (!mentorId) return null;
//     const idKey = typeof mentorId === "object" ? mentorId._id || "" : mentorId;
//     return mentorsMap[idKey] || null;
//   };

//   const handleCancelRequest = async (requestId) => {
//     if (!window.confirm("Are you sure you want to cancel this request?")) return;
//     try {
//       await axios.delete(`${API_BASE}/api/connection-requests/${requestId}`);
//       setRequests((prev) => {
//         const updated = prev.filter((r) => r._id !== requestId);
//         if (selectedRequest?._id === requestId) {
//           setSelectedRequest(updated[0] || null);
//           setDrawerOpen(false);
//         }
//         return updated;
//       });
//     } catch (err) {
//       console.error("Error cancelling request:", err);
//       alert("Failed to cancel request. Try again.");
//     }
//   };

//   // ── Pagination ─────────────────────────────────────────────────
//   const indexOfLast      = currentPage * requestsPerPage;
//   const indexOfFirst     = indexOfLast - requestsPerPage;
//   const currentRequests  = requests.slice(indexOfFirst, indexOfLast);
//   const totalPages       = Math.max(1, Math.ceil(requests.length / requestsPerPage));

//   const handleNext = () => { if (currentPage < totalPages) setCurrentPage((p) => p + 1); };
//   const handlePrev = () => { if (currentPage > 1)          setCurrentPage((p) => p - 1); };

//   // ── Shared: Detail panel content (used in both drawer & side card) ──
//   const DetailContent = () => {
//     if (!selectedRequest) return (
//       <Box height="100%" display="flex" flexDirection="column" alignItems="center" justifyContent="center" sx={{ py: 8 }}>
//         <Box sx={{ width: 80, height: 80, borderRadius: "50%", bgcolor: alpha("#00AEEF", 0.1), display: "flex", alignItems: "center", justifyContent: "center", mb: 3 }}>
//           <SendIcon sx={{ fontSize: 36, color: "#00AEEF" }} />
//         </Box>
//         <Typography variant="h6" sx={{ color: "#64748b", fontWeight: 500, textAlign: "center" }}>
//           Select a request to view details
//         </Typography>
//       </Box>
//     );

//     const m          = getMentorById(selectedRequest.mentorId);
//     const mentorName = m?.fullName || m?.email || "Mentor";

//     return (
//       <>
//         {/* Header row */}
//         <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 3 }}>
//           <Stack direction="row" alignItems="center" spacing={1.5}>
//             <Box sx={{ width: 6, height: 24, background: "linear-gradient(135deg,#00AEEF 0%,#0090D9 100%)", borderRadius: 1 }} />
//             <Typography variant="h6" fontWeight={700} sx={{ color: "#0f172a" }}>Request Details</Typography>
//           </Stack>
//           {/* Close drawer button — only on mobile */}
//           {isMobile && (
//             <IconButton size="small" onClick={() => setDrawerOpen(false)} sx={{ color: "#64748b" }}>
//               <Close fontSize="small" />
//             </IconButton>
//           )}
//         </Stack>

//         <CardContent sx={{ p: 0 }}>
//           {/* Mentor gradient banner */}
//           <Box sx={{ p: { xs: 2, sm: 3 }, mb: 3, borderRadius: 3, background: "linear-gradient(135deg,#00AEEF 0%,#0090D9 100%)", boxShadow: "0 8px 24px rgba(0,174,239,0.25)" }}>
//             <Stack direction="row" spacing={2} alignItems="center">
//               <Avatar sx={{ width: { xs: 56, sm: 72 }, height: { xs: 56, sm: 72 }, bgcolor: "white", color: "#00AEEF", fontSize: { xs: 22, sm: 28 }, fontWeight: 700, boxShadow: "0 4px 12px rgba(0,0,0,0.1)", flexShrink: 0 }}>
//                 {mentorName.charAt(0).toUpperCase()}
//               </Avatar>
//               <Box sx={{ minWidth: 0 }}>
//                 <Typography sx={{ fontWeight: 700, fontSize: { xs: 15, sm: 18 }, color: "white", mb: 0.5, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
//                   {mentorName}
//                 </Typography>
//                 <Chip label="Mentor" size="small" sx={{ bgcolor: alpha("#ffffff", 0.25), color: "white", fontWeight: 600, height: 24 }} />
//               </Box>
//             </Stack>
//           </Box>

//           {/* Detail fields */}
//           <Stack spacing={2.5}>
//             {[
//               { label: "Goal",                    value: selectedRequest.goal },
//               { label: "Areas of Interest",       value: selectedRequest.areasOfInterest },
//               { label: "Communication Frequency", value: selectedRequest.communicationFrequency },
//               { label: "Description",             value: selectedRequest.description || "No description provided" },
//             ].map((field, i) => (
//               <React.Fragment key={i}>
//                 <Box>
//                   <Typography variant="overline" sx={{ color: "#64748b", fontWeight: 700, letterSpacing: 1, fontSize: "0.7rem" }}>
//                     {field.label}
//                   </Typography>
//                   <Typography variant="body2" sx={{ color: "#0f172a", mt: 0.5, fontWeight: 500, lineHeight: 1.6, fontSize: { xs: 13, sm: 15 } }}>
//                     {field.value}
//                   </Typography>
//                 </Box>
//                 {i < 3 && <Divider sx={{ borderColor: "#e2e8f0" }} />}
//               </React.Fragment>
//             ))}

//             <Divider sx={{ borderColor: "#e2e8f0" }} />

//             <Box>
//               <Typography variant="overline" sx={{ color: "#64748b", fontWeight: 700, letterSpacing: 1, fontSize: "0.7rem" }}>Status</Typography>
//               <Box mt={1}>
//                 <Chip
//                   icon={<AccessTimeIcon />}
//                   label={selectedRequest.status || "pending"}
//                   sx={{ bgcolor: alpha("#F57E47", 0.1), color: "#F57E47", fontWeight: 600, fontSize: "0.8rem", py: 2, px: 1, "& .MuiChip-icon": { color: "#F57E47" } }}
//                 />
//               </Box>
//             </Box>
//           </Stack>
//         </CardContent>

//         <Divider sx={{ my: 3, borderColor: "#e2e8f0" }} />

//         <Box display="flex" justifyContent={{ xs: "center", sm: "flex-end" }}>
//           <Button
//             variant="contained"
//             startIcon={<Close />}
//             onClick={() => handleCancelRequest(selectedRequest._id)}
//             fullWidth={isMobile}
//             sx={{
//               py: 1.5, px: { xs: 2, sm: 4 },
//               textTransform: "none", fontWeight: 600, borderRadius: 2.5,
//               background: "linear-gradient(135deg,#F57E47 0%,#FF6B35 100%)",
//               boxShadow: "0 4px 16px rgba(245,126,71,0.3)",
//               fontSize: { xs: 13, sm: 15 },
//               "&:hover": { background: "linear-gradient(135deg,#FF6B35 0%,#F5531E 100%)", boxShadow: "0 6px 20px rgba(245,126,71,0.4)", transform: "translateY(-1px)" },
//               transition: "all 0.3s ease",
//             }}
//           >
//             Cancel Request
//           </Button>
//         </Box>
//       </>
//     );
//   };

//   return (
//     <Box sx={{ bgcolor: "#f8fafc", minHeight: "100vh", display: "flex", flexDirection: "column" }}>
//       <TopBar />

//       <Box sx={{ px: { xs: "12px", sm: "24px", md: "40px" }, py: { xs: 3, sm: 4, md: 5 }, maxWidth: "1400px", mx: "auto", width: "100%", boxSizing: "border-box", flex: 1 }}>

//         {/* ── Page Header ─────────────────────────────────────────── */}
//         <Box sx={{ mb: { xs: 3, sm: 5 }, textAlign: "center", position: "relative" }}>
//           <Box sx={{ position: "absolute", top: -20, left: "50%", transform: "translateX(-50%)", width: 80, height: 4, background: "linear-gradient(135deg,#00AEEF 0%,#0090D9 100%)", borderRadius: 2 }} />
//           <Typography variant="h4" sx={{ fontWeight: 700, color: "#0f172a", mb: 1, fontSize: { xs: "1.4rem", sm: "1.75rem", md: "2.125rem" } }}>
//             Connection Requests
//           </Typography>
//           <Typography variant="body1" sx={{ color: "#64748b", maxWidth: 600, mx: "auto", fontSize: { xs: 13, sm: 15 } }}>
//             Manage your pending mentor connection requests
//           </Typography>
//         </Box>

//         {/* ── Loading ─────────────────────────────────────────────── */}
//         {(loadingRequests || loadingMentors) ? (
//           <Box display="flex" justifyContent="center" alignItems="center" sx={{ mt: 8 }}>
//             <CircularProgress size={48} sx={{ color: "#00AEEF" }} />
//           </Box>

//         /* ── Error ──────────────────────────────────────────────── */
//         ) : error ? (
//           <Box sx={{ textAlign: "center", py: 8, px: 3, bgcolor: alpha("#F57E47", 0.05), borderRadius: 3, border: `1px solid ${alpha("#F57E47", 0.2)}` }}>
//             <Typography color="error" sx={{ fontWeight: 500 }}>{error}</Typography>
//           </Box>

//         /* ── Empty state ────────────────────────────────────────── */
//         ) : requests.length === 0 ? (
//           <Box sx={{ textAlign: "center", py: { xs: 5, sm: 8 }, px: { xs: 2, sm: 3 }, bgcolor: "white", borderRadius: 4, boxShadow: "0 4px 24px rgba(0,0,0,0.06)" }}>
//             <Box sx={{ width: 80, height: 80, borderRadius: "50%", background: "linear-gradient(135deg,#00AEEF 0%,#0090D9 100%)", display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 3, boxShadow: "0 8px 24px rgba(0,174,239,0.3)" }}>
//               <SendIcon sx={{ fontSize: 36, color: "white" }} />
//             </Box>
//             <Typography sx={{ fontSize: { xs: "1rem", sm: "1.25rem" }, fontWeight: 600, color: "#0f172a", mb: 1 }}>
//               No Pending Requests
//             </Typography>
//             <Typography sx={{ color: "#64748b", mb: 4, maxWidth: 500, mx: "auto", fontSize: { xs: 13, sm: 15 } }}>
//               You haven't sent any connection requests yet. Browse our mentors to find the perfect match for your goals.
//             </Typography>
//             <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="center" alignItems="center">
//               <Button variant="contained" startIcon={<GroupIcon />}
//                 sx={{ py: 1.5, px: 4, fontWeight: 600, textTransform: "none", borderRadius: 2.5, background: "linear-gradient(135deg,#00AEEF 0%,#0090D9 100%)", boxShadow: "0 4px 16px rgba(0,174,239,0.3)", fontSize: { xs: 13, sm: 16 }, width: { xs: "100%", sm: "auto" }, "&:hover": { background: "linear-gradient(135deg,#0090D9 0%,#007AB8 100%)", transform: "translateY(-1px)" }, transition: "all 0.3s ease" }}
//                 onClick={() => navigate("/mentor")}
//               >Browse Mentors</Button>
//               <Button variant="outlined" startIcon={<HomeIcon />}
//                 sx={{ py: 1.5, px: 4, fontWeight: 600, textTransform: "none", borderRadius: 2.5, borderWidth: 2, borderColor: "#00AEEF", color: "#00AEEF", fontSize: { xs: 13, sm: 16 }, width: { xs: "100%", sm: "auto" }, "&:hover": { borderWidth: 2, borderColor: "#0090D9", bgcolor: alpha("#00AEEF", 0.05), transform: "translateY(-1px)" }, transition: "all 0.3s ease" }}
//                 onClick={() => navigate("/learner-dash")}
//               >Dashboard</Button>
//             </Stack>
//           </Box>

//         /* ── Main content ───────────────────────────────────────── */
//         ) : (
//           <Box sx={{ display: "flex", flexDirection: { xs: "column", lg: "row" }, gap: { xs: 2, sm: 3 }, alignItems: "stretch", width: "100%", boxSizing: "border-box" }}>

//             {/* ── Left: Request list ────────────────────────────── */}
//             <Paper elevation={0} sx={{
//               // On desktop: fixed width left panel. On mobile: full width.
//               flex: { lg: "0 0 380px" },
//               width: { xs: "100%", lg: "auto" },
//               borderRadius: 4, p: { xs: 2, sm: 3 },
//               bgcolor: "white",
//               maxHeight: { lg: "80vh" },
//               overflowY: "auto",
//               border: "1px solid #e2e8f0",
//               boxShadow: "0 4px 24px rgba(0,0,0,0.06)",
//               boxSizing: "border-box",
//             }}>
//               {/* List header */}
//               <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2.5 }}>
//                 <Box sx={{ width: 6, height: 24, background: "linear-gradient(135deg,#00AEEF 0%,#0090D9 100%)", borderRadius: 1, flexShrink: 0 }} />
//                 <Typography variant="h6" fontWeight={700} sx={{ color: "#0f172a", fontSize: { xs: 15, sm: 17 } }}>
//                   Your Requests
//                 </Typography>
//                 <Chip label={requests.length} size="small" sx={{ bgcolor: alpha("#00AEEF", 0.1), color: "#00AEEF", fontWeight: 600 }} />
//               </Stack>

//               {/* Request cards */}
//               {currentRequests.map((req) => {
//                 const mentor     = getMentorById(req.mentorId);
//                 const mentorName = mentor?.fullName || mentor?.email || "Mentor";
//                 const initial    = mentorName.charAt(0).toUpperCase();
//                 const isSelected = selectedRequest?._id === req._id;

//                 return (
//                   <Paper
//                     key={req._id}
//                     elevation={0}
//                     onClick={() => {
//                       setSelectedRequest(req);
//                       // On mobile, open the drawer
//                       if (isMobile) setDrawerOpen(true);
//                     }}
//                     sx={{
//                       p: { xs: 1.5, sm: 2.5 }, mb: 1.5,
//                       borderRadius: 3, cursor: "pointer",
//                       transition: "all 0.3s ease",
//                       display: "flex", alignItems: "center",
//                       justifyContent: "space-between", gap: 1.5,
//                       border: isSelected ? "2px solid #00AEEF" : "1px solid #e2e8f0",
//                       bgcolor: isSelected ? alpha("#00AEEF", 0.04) : "white",
//                       width: "100%", boxSizing: "border-box",
//                       "&:hover": { bgcolor: alpha("#00AEEF", 0.04), borderColor: "#00AEEF", transform: "translateY(-2px)", boxShadow: "0 8px 16px rgba(0,0,0,0.08)" },
//                     }}
//                   >
//                     <Stack direction="row" alignItems="center" spacing={{ xs: 1, sm: 2 }} flex={1} minWidth={0}>
//                       <Avatar sx={{ width: { xs: 42, sm: 56 }, height: { xs: 42, sm: 56 }, background: "linear-gradient(135deg,#00AEEF 0%,#0090D9 100%)", fontWeight: 700, fontSize: { xs: "1rem", sm: "1.25rem" }, boxShadow: "0 4px 12px rgba(0,174,239,0.3)", flexShrink: 0 }}>
//                         {initial}
//                       </Avatar>
//                       <Box flex={1} minWidth={0}>
//                         <Typography fontWeight={600} sx={{ color: "#0f172a", mb: 0.5, fontSize: { xs: 12, sm: 15 }, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
//                           {req.goal}
//                         </Typography>
//                         <Typography variant="body2" sx={{ color: "#64748b", mb: 0.5, fontSize: { xs: 11, sm: 13 }, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
//                           To: <strong>{mentorName}</strong>
//                         </Typography>
//                         <Chip
//                           icon={<AccessTimeIcon sx={{ fontSize: 12 }} />}
//                           label={req.status || "pending"}
//                           size="small"
//                           sx={{ bgcolor: alpha("#F57E47", 0.1), color: "#F57E47", fontWeight: 600, fontSize: "0.7rem", height: 22, "& .MuiChip-icon": { color: "#F57E47" } }}
//                         />
//                       </Box>
//                     </Stack>

//                     <Tooltip title="Cancel Request">
//                       <IconButton
//                         size="small"
//                         onClick={(e) => { e.stopPropagation(); handleCancelRequest(req._id); }}
//                         sx={{ color: "#F57E47", bgcolor: alpha("#F57E47", 0.1), flexShrink: 0, "&:hover": { bgcolor: alpha("#F57E47", 0.2) } }}
//                       >
//                         <Close fontSize="small" />
//                       </IconButton>
//                     </Tooltip>
//                   </Paper>
//                 );
//               })}

//               {/* Pagination */}
//               <Box display="flex" justifyContent="space-between" alignItems="center" mt={2.5} pt={2.5} borderTop="1px solid #e2e8f0">
//                 <Button startIcon={<ArrowBack />} onClick={handlePrev} disabled={currentPage === 1}
//                   sx={{ textTransform: "none", fontWeight: 600, fontSize: { xs: 12, sm: 14 }, color: currentPage === 1 ? "#cbd5e1" : "#00AEEF", "&:hover": { bgcolor: alpha("#00AEEF", 0.08) } }}>
//                   Prev
//                 </Button>
//                 <Typography variant="body2" sx={{ fontWeight: 500, color: "#64748b", fontSize: { xs: 11, sm: 13 } }}>
//                   {currentPage} / {totalPages}
//                 </Typography>
//                 <Button endIcon={<ArrowForward />} onClick={handleNext} disabled={currentPage === totalPages}
//                   sx={{ textTransform: "none", fontWeight: 600, fontSize: { xs: 12, sm: 14 }, color: currentPage === totalPages ? "#cbd5e1" : "#00AEEF", "&:hover": { bgcolor: alpha("#00AEEF", 0.08) } }}>
//                   Next
//                 </Button>
//               </Box>
//             </Paper>

//             {/* ── Right: Detail panel — desktop only ───────────── */}
//             {!isMobile && (
//               <Card elevation={0} sx={{
//                 flex: 1, p: { sm: 3, md: 4 },
//                 borderRadius: 4,
//                 minHeight: { lg: "80vh" },
//                 bgcolor: "white",
//                 border: "1px solid #e2e8f0",
//                 boxShadow: "0 4px 24px rgba(0,0,0,0.06)",
//                 boxSizing: "border-box",
//                 overflow: "auto",
//               }}>
//                 <DetailContent />
//               </Card>
//             )}
//           </Box>
//         )}
//       </Box>

//       {/* ── Mobile: detail panel in bottom drawer ──────────────── */}
//       {isMobile && (
//         <Drawer
//           anchor="bottom"
//           open={drawerOpen}
//           onClose={() => setDrawerOpen(false)}
//           PaperProps={{
//             sx: {
//               borderTopLeftRadius: 20,
//               borderTopRightRadius: 20,
//               maxHeight: "88vh",
//               overflowY: "auto",
//               px: "16px",
//               pt: "20px",
//               pb: "32px",
//             },
//           }}
//         >
//           {/* Drag handle */}
//           <Box sx={{ width: 40, height: 4, bgcolor: "#e2e8f0", borderRadius: 2, mx: "auto", mb: 2.5 }} />
//           <DetailContent />
//         </Drawer>
//       )}

//       <Footer />
//     </Box>
//   );
// };

// export default PendingRequests;

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  IconButton,
  CircularProgress,
  Tooltip,
  Paper,
  Divider,
  Button,
  Card,
  CardContent,
  Avatar,
  Stack,
  Chip,
  alpha,
  Drawer,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  ArrowBack,
  ArrowForward,
  Close,
  HourglassEmpty,
  CheckCircleOutline,
  CancelOutlined,
} from "@mui/icons-material";
import GroupIcon from "@mui/icons-material/Group";
import HomeIcon from "@mui/icons-material/Home";
import SendIcon from "@mui/icons-material/Send";
import axios from "axios";
import TopBar from "../globalComponents/topbar";
import Footer from "../globalComponents/footer";

// ── Brand palette ────────────────────────────────────────────────────────────
const C = {
  primary: "#0A2E8A",
  primaryDark: "#061E5C",
  primaryLight: "#3B5BC9",
  primarySoft: "#E8EDFC",
  primarySofter: "#F2F5FE",
  secondary: "#10682A",
  secondaryDark: "#0A4A1C",
  secondaryLight: "#2E9148",
  secondarySoft: "#E3F2E8",
  secondarySofter: "#F0F8F3",
  bg: "#FAFBFC",
  paper: "#FFFFFF",
  border: "#E5E9F0",
  borderSoft: "#EEF1F6",
  textPrimary: "#0D1117",
  textSecondary: "#5B6B7E",
  textMuted: "#8A9BB0",
  warning: "#D97706",
  warningSoft: "#FEF3C7",
  error: "#DC2626",
  errorSoft: "#FEE2E2",
};

// Status → visual config
const STATUS_CONFIG = {
  pending: {
    label: "Pending",
    icon: <HourglassEmpty sx={{ fontSize: 12 }} />,
    bg: C.warningSoft,
    fg: C.warning,
    rank: 0,
  },
  accepted: {
    label: "Accepted",
    icon: <CheckCircleOutline sx={{ fontSize: 12 }} />,
    bg: C.secondarySoft,
    fg: C.secondary,
    rank: 1,
  },
  rejected: {
    label: "Rejected",
    icon: <CancelOutlined sx={{ fontSize: 12 }} />,
    bg: C.errorSoft,
    fg: C.error,
    rank: 2,
  },
};

const statusOf = (req) => (req.status || "pending").toLowerCase();
const statusConfig = (req) => STATUS_CONFIG[statusOf(req)] || STATUS_CONFIG.pending;

const PendingRequests = () => {
  const [requests, setRequests] = useState([]);
  const [mentorsMap, setMentorsMap] = useState({});
  const [loadingRequests, setLoadingRequests] = useState(false);
  const [loadingMentors, setLoadingMentors] = useState(false);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const requestsPerPage = 4;
  const API_BASE = "https://backend-global-1vq9.onrender.com";

  // ── Fetch mentors ──────────────────────────────────────────────
  useEffect(() => {
    (async () => {
      try {
        setLoadingMentors(true);
        const res = await axios.get(`${API_BASE}/api/mentor/list`);
        const mentors = res.data?.mentors || [];
        const map = {};
        for (const m of mentors) {
          const idKey = typeof m.userId === "object" ? m.userId._id || "" : m.userId;
          if (idKey) map[idKey] = m;
        }
        setMentorsMap(map);
      } catch (err) {
        console.error("Error fetching mentors:", err);
      } finally {
        setLoadingMentors(false);
      }
    })();
  }, []);

  // ── Fetch requests ─────────────────────────────────────────────
  useEffect(() => {
    (async () => {
      try {
        setLoadingRequests(true);
        const user = JSON.parse(localStorage.getItem("user"));
        const userId = user?.id || user?._id;

        if (!userId) { setError("User not logged in"); return; }

        const res = await axios.get(`${API_BASE}/api/connection-requests/mentee/${userId}`);
        const fetched = res.data?.data || [];

        // Sort: pending → accepted → rejected; within each group, newest first
        const sorted = [...fetched].sort((a, b) => {
          const ra = statusConfig(a).rank;
          const rb = statusConfig(b).rank;
          if (ra !== rb) return ra - rb;
          const da = new Date(a.createdAt || 0).getTime();
          const db = new Date(b.createdAt || 0).getTime();
          return db - da;
        });

        setRequests(sorted);

        if (sorted.length > 0) {
          setSelectedRequest(sorted[0]);
          setCurrentPage(1);
        } else {
          setSelectedRequest(null);
        }
      } catch (err) {
        console.error("Error fetching mentee requests:", err);
        setError("Failed to fetch connection requests.");
      } finally {
        setLoadingRequests(false);
      }
    })();
  }, []);

  const getMentorById = (mentorId) => {
    if (!mentorId) return null;
    const idKey = typeof mentorId === "object" ? mentorId._id || "" : mentorId;
    return mentorsMap[idKey] || null;
  };

  const handleCancelRequest = async (requestId) => {
    if (!window.confirm("Are you sure you want to cancel this request?")) return;
    try {
      await axios.delete(`${API_BASE}/api/connection-requests/${requestId}`);
      setRequests((prev) => {
        const updated = prev.filter((r) => r._id !== requestId);
        if (selectedRequest?._id === requestId) {
          setSelectedRequest(updated[0] || null);
          setDrawerOpen(false);
        }
        return updated;
      });
    } catch (err) {
      console.error("Error cancelling request:", err);
      alert("Failed to cancel request. Try again.");
    }
  };

  // ── Pagination ─────────────────────────────────────────────────
  const indexOfLast = currentPage * requestsPerPage;
  const indexOfFirst = indexOfLast - requestsPerPage;
  const currentRequests = requests.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.max(1, Math.ceil(requests.length / requestsPerPage));

  const handleNext = () => { if (currentPage < totalPages) setCurrentPage((p) => p + 1); };
  const handlePrev = () => { if (currentPage > 1) setCurrentPage((p) => p - 1); };

  // ── Status counts for the header chips ─────────────────────────
  const counts = {
    pending: requests.filter((r) => statusOf(r) === "pending").length,
    accepted: requests.filter((r) => statusOf(r) === "accepted").length,
    rejected: requests.filter((r) => statusOf(r) === "rejected").length,
  };

  // ── Detail panel content (used in drawer + side card) ─────────
  const DetailContent = () => {
    if (!selectedRequest) return (
      <Box height="100%" display="flex" flexDirection="column" alignItems="center" justifyContent="center" sx={{ py: 8 }}>
        <Box sx={{
          width: 80, height: 80, borderRadius: "50%",
          background: `linear-gradient(135deg, ${C.primary}, ${C.primaryLight})`,
          display: "flex", alignItems: "center", justifyContent: "center", mb: 3,
          boxShadow: `0 8px 20px ${C.primary}30`,
        }}>
          <SendIcon sx={{ fontSize: 36, color: "#fff" }} />
        </Box>
        <Typography variant="h6" sx={{ color: C.textSecondary, fontWeight: 500, textAlign: "center" }}>
          Select a request to view details
        </Typography>
      </Box>
    );

    const m = getMentorById(selectedRequest.mentorId);
    const mentorName = m?.fullName || m?.email || "Mentor";
    const sc = statusConfig(selectedRequest);
    const isPending = statusOf(selectedRequest) === "pending";

    return (
      <>
        {/* Header row */}
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 3 }}>
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Box sx={{
              width: 6, height: 24,
              background: `linear-gradient(135deg, ${C.primary}, ${C.primaryLight})`,
              borderRadius: 1,
            }} />
            <Typography variant="h6" fontWeight={700} sx={{ color: C.textPrimary }}>
              Request Details
            </Typography>
          </Stack>
          {isMobile && (
            <IconButton size="small" onClick={() => setDrawerOpen(false)} sx={{ color: C.textSecondary }}>
              <Close fontSize="small" />
            </IconButton>
          )}
        </Stack>

        <CardContent sx={{ p: 0 }}>
          {/* Mentor gradient banner */}
          <Box sx={{
            position: "relative",
            p: { xs: 2, sm: 3 }, mb: 3, borderRadius: 3,
            background: `linear-gradient(135deg, ${C.primary} 0%, ${C.primaryDark} 100%)`,
            boxShadow: `0 8px 24px ${C.primary}30`,
            overflow: "hidden",
          }}>
            {/* Decorative green orb */}
            <Box sx={{
              position: "absolute",
              top: "-50%", right: "-15%",
              width: 160, height: 160,
              borderRadius: "50%",
              background: `radial-gradient(circle, ${C.secondary}40 0%, transparent 70%)`,
              pointerEvents: "none",
            }} />
            <Stack direction="row" spacing={2} alignItems="center" sx={{ position: "relative", zIndex: 1 }}>
              <Avatar sx={{
                width: { xs: 56, sm: 72 }, height: { xs: 56, sm: 72 },
                bgcolor: "white", color: C.primary,
                fontSize: { xs: 22, sm: 28 }, fontWeight: 700,
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                flexShrink: 0,
              }}>
                {mentorName.charAt(0).toUpperCase()}
              </Avatar>
              <Box sx={{ minWidth: 0 }}>
                <Typography sx={{
                  fontWeight: 700, fontSize: { xs: 15, sm: 18 },
                  color: "white", mb: 0.5,
                  overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                }}>
                  {mentorName}
                </Typography>
                <Chip
                  label="Mentor"
                  size="small"
                  sx={{
                    bgcolor: alpha("#ffffff", 0.25),
                    color: "white", fontWeight: 600, height: 24,
                  }}
                />
              </Box>
            </Stack>
          </Box>

          {/* Detail fields */}
          <Stack spacing={2.5}>
            {[
              { label: "Goal", value: selectedRequest.goal },
              { label: "Areas of Interest", value: selectedRequest.areasOfInterest },
              { label: "Communication Frequency", value: selectedRequest.communicationFrequency },
              { label: "Description", value: selectedRequest.description || "No description provided" },
            ].map((field, i) => (
              <React.Fragment key={i}>
                <Box>
                  <Typography variant="overline" sx={{
                    color: C.textMuted, fontWeight: 700,
                    letterSpacing: 1, fontSize: "0.7rem",
                  }}>
                    {field.label}
                  </Typography>
                  <Typography variant="body2" sx={{
                    color: C.textPrimary, mt: 0.5,
                    fontWeight: 500, lineHeight: 1.6,
                    fontSize: { xs: 13, sm: 15 },
                  }}>
                    {field.value}
                  </Typography>
                </Box>
                {i < 3 && <Divider sx={{ borderColor: C.borderSoft }} />}
              </React.Fragment>
            ))}

            <Divider sx={{ borderColor: C.borderSoft }} />

            <Box>
              <Typography variant="overline" sx={{
                color: C.textMuted, fontWeight: 700,
                letterSpacing: 1, fontSize: "0.7rem",
              }}>
                Status
              </Typography>
              <Box mt={1}>
                <Chip
                  icon={sc.icon}
                  label={sc.label}
                  sx={{
                    bgcolor: sc.bg, color: sc.fg,
                    fontWeight: 700, fontSize: "0.8rem",
                    py: 2, px: 1,
                    "& .MuiChip-icon": { color: sc.fg },
                  }}
                />
              </Box>
            </Box>
          </Stack>
        </CardContent>

        <Divider sx={{ my: 3, borderColor: C.borderSoft }} />

        <Box display="flex" justifyContent={{ xs: "center", sm: "flex-end" }}>
          <Button
            variant="contained"
            startIcon={<Close />}
            onClick={() => handleCancelRequest(selectedRequest._id)}
            fullWidth={isMobile}
            sx={{
              py: 1.5, px: { xs: 2, sm: 4 },
              textTransform: "none", fontWeight: 700,
              borderRadius: 2.5,
              bgcolor: C.error,
              boxShadow: `0 4px 14px ${C.error}30`,
              fontSize: { xs: 13, sm: 15 },
              "&:hover": {
                bgcolor: "#B91C1C",
                boxShadow: `0 6px 18px ${C.error}45`,
                transform: "translateY(-1px)",
              },
              transition: "all 0.2s ease",
            }}
          >
            {isPending ? "Cancel Request" : "Remove Request"}
          </Button>
        </Box>
      </>
    );
  };

  return (
    <Box sx={{ bgcolor: C.bg, minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <TopBar />

      <Box sx={{
        px: { xs: "12px", sm: "24px", md: "40px" },
        py: { xs: 3, sm: 4, md: 5 },
        maxWidth: "1400px", mx: "auto", width: "100%",
        boxSizing: "border-box", flex: 1,
      }}>

        {/* ── Hero header (compact) ───────────────────────────────── */}
        <Paper
          elevation={0}
          sx={{
            position: "relative",
            borderRadius: 3, overflow: "hidden",
            background: `linear-gradient(135deg, ${C.primary} 0%, ${C.primaryDark} 100%)`,
            p: { xs: 3, sm: 4 },
            mb: { xs: 2.5, sm: 3.5 },
            color: "#fff",
            boxShadow: `0 6px 24px ${C.primary}30`,
          }}
        >
          <Box sx={{
            position: "absolute",
            top: "-40%", right: "-10%",
            width: { xs: 180, sm: 240 }, height: { xs: 180, sm: 240 },
            borderRadius: "50%",
            background: `radial-gradient(circle, ${C.secondary}40 0%, transparent 70%)`,
            pointerEvents: "none",
          }} />

          <Box sx={{ position: "relative", zIndex: 1 }}>
            <Typography sx={{
              fontSize: { xs: 11, sm: 12 },
              fontWeight: 700, letterSpacing: 1.5,
              textTransform: "uppercase",
              color: "rgba(255,255,255,0.7)", mb: 0.75,
            }}>
              My Connections
            </Typography>
            <Typography sx={{
              fontWeight: 800, fontSize: { xs: 22, sm: 28, md: 32 },
              color: "#fff", lineHeight: 1.15,
              mb: { xs: 0.75, sm: 1 }, letterSpacing: -0.5,
            }}>
              Connection Requests
            </Typography>
            <Typography sx={{
              color: "rgba(255,255,255,0.85)",
              fontSize: { xs: 13, sm: 14, md: 15 },
              maxWidth: 520, lineHeight: 1.5,
            }}>
              Track and manage the mentor connections you've requested
            </Typography>

            {/* Status count chips */}
            {requests.length > 0 && (
              <Stack direction="row" spacing={1} mt={2} flexWrap="wrap" useFlexGap>
                {counts.pending > 0 && (
                  <Chip
                    icon={<HourglassEmpty sx={{ fontSize: "14px !important", color: "#fff !important" }} />}
                    label={`${counts.pending} pending`}
                    size="small"
                    sx={{
                      bgcolor: "rgba(255,255,255,0.18)",
                      color: "#fff", fontWeight: 600,
                      backdropFilter: "blur(4px)",
                      "& .MuiChip-icon": { color: "#fff" },
                    }}
                  />
                )}
                {counts.accepted > 0 && (
                  <Chip
                    icon={<CheckCircleOutline sx={{ fontSize: "14px !important", color: "#fff !important" }} />}
                    label={`${counts.accepted} accepted`}
                    size="small"
                    sx={{
                      bgcolor: alpha(C.secondary, 0.85),
                      color: "#fff", fontWeight: 600,
                      "& .MuiChip-icon": { color: "#fff" },
                    }}
                  />
                )}
                {counts.rejected > 0 && (
                  <Chip
                    icon={<CancelOutlined sx={{ fontSize: "14px !important", color: "#fff !important" }} />}
                    label={`${counts.rejected} rejected`}
                    size="small"
                    sx={{
                      bgcolor: "rgba(255,255,255,0.18)",
                      color: "#fff", fontWeight: 600,
                      "& .MuiChip-icon": { color: "#fff" },
                    }}
                  />
                )}
              </Stack>
            )}
          </Box>
        </Paper>

        {/* ── Loading ─────────────────────────────────────────────── */}
        {(loadingRequests || loadingMentors) ? (
          <Box display="flex" justifyContent="center" alignItems="center" sx={{ mt: 8 }}>
            <CircularProgress size={48} sx={{ color: C.primary }} />
          </Box>

        /* ── Error ──────────────────────────────────────────────── */
        ) : error ? (
          <Box sx={{
            textAlign: "center", py: 8, px: 3,
            bgcolor: C.errorSoft, borderRadius: 3,
            border: `1px solid ${alpha(C.error, 0.2)}`,
          }}>
            <Typography sx={{ color: C.error, fontWeight: 600 }}>{error}</Typography>
          </Box>

        /* ── Empty state ────────────────────────────────────────── */
        ) : requests.length === 0 ? (
          <Box sx={{
            textAlign: "center", py: { xs: 5, sm: 8 }, px: { xs: 2, sm: 3 },
            bgcolor: C.paper, borderRadius: 4,
            border: `1px solid ${C.border}`,
            boxShadow: "0 4px 24px rgba(0,0,0,0.04)",
          }}>
            <Box sx={{
              width: 80, height: 80, borderRadius: "50%",
              background: `linear-gradient(135deg, ${C.primary}, ${C.primaryDark})`,
              display: "flex", alignItems: "center", justifyContent: "center",
              mx: "auto", mb: 3,
              boxShadow: `0 8px 24px ${C.primary}30`,
            }}>
              <SendIcon sx={{ fontSize: 36, color: "white" }} />
            </Box>
            <Typography sx={{
              fontSize: { xs: "1rem", sm: "1.25rem" },
              fontWeight: 700, color: C.textPrimary, mb: 1,
            }}>
              No Connection Requests
            </Typography>
            <Typography sx={{
              color: C.textSecondary, mb: 4,
              maxWidth: 500, mx: "auto",
              fontSize: { xs: 13, sm: 15 },
            }}>
              You haven't sent any connection requests yet. Browse mentors to find the perfect match for your goals.
            </Typography>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="center" alignItems="center">
              <Button
                variant="contained"
                startIcon={<GroupIcon />}
                sx={{
                  py: 1.5, px: 4,
                  fontWeight: 700, textTransform: "none",
                  borderRadius: 2.5,
                  bgcolor: C.primary,
                  boxShadow: `0 4px 14px ${C.primary}30`,
                  fontSize: { xs: 13, sm: 15 },
                  width: { xs: "100%", sm: "auto" },
                  "&:hover": {
                    bgcolor: C.primaryDark,
                    boxShadow: `0 6px 18px ${C.primary}45`,
                    transform: "translateY(-1px)",
                  },
                  transition: "all 0.2s ease",
                }}
                onClick={() => navigate("/mentor")}
              >
                Browse Mentors
              </Button>
              <Button
                variant="contained"
                startIcon={<HomeIcon />}
                sx={{
                  py: 1.5, px: 4,
                  fontWeight: 700, textTransform: "none",
                  borderRadius: 2.5,
                  bgcolor: C.secondary,
                  boxShadow: `0 4px 14px ${C.secondary}30`,
                  fontSize: { xs: 13, sm: 15 },
                  width: { xs: "100%", sm: "auto" },
                  "&:hover": {
                    bgcolor: C.secondaryDark,
                    boxShadow: `0 6px 18px ${C.secondary}45`,
                    transform: "translateY(-1px)",
                  },
                  transition: "all 0.2s ease",
                }}
                onClick={() => navigate("/learner-dash")}
              >
                Dashboard
              </Button>
            </Stack>
          </Box>

        /* ── Main content ───────────────────────────────────────── */
        ) : (
          <Box sx={{
            display: "flex", flexDirection: { xs: "column", lg: "row" },
            gap: { xs: 2, sm: 3 }, alignItems: "stretch",
            width: "100%", boxSizing: "border-box",
          }}>

            {/* ── Left: Request list ────────────────────────────── */}
            <Paper
              elevation={0}
              sx={{
                position: "relative",
                flex: { lg: "0 0 380px" },
                width: { xs: "100%", lg: "auto" },
                borderRadius: 3, p: { xs: 2, sm: 3 },
                bgcolor: C.paper,
                maxHeight: { lg: "80vh" },
                overflowY: "auto",
                border: `1px solid ${C.border}`,
                boxShadow: "0 2px 12px rgba(13,17,23,0.04)",
                boxSizing: "border-box",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  top: 0, left: 0, right: 0,
                  height: "3px",
                  background: `linear-gradient(90deg, ${C.primary}, ${C.primary}88)`,
                },
              }}
            >
              {/* List header */}
              <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2.5, mt: 0.5 }}>
                <Typography variant="h6" fontWeight={700} sx={{
                  color: C.textPrimary, fontSize: { xs: 15, sm: 16 },
                  letterSpacing: -0.2,
                }}>
                  Your Requests
                </Typography>
                <Chip
                  label={requests.length}
                  size="small"
                  sx={{
                    bgcolor: C.primarySoft, color: C.primary,
                    fontWeight: 700, height: 22,
                    "& .MuiChip-label": { px: 1 },
                  }}
                />
              </Stack>

              {/* Request cards */}
              {currentRequests.map((req) => {
                const mentor = getMentorById(req.mentorId);
                const mentorName = mentor?.fullName || mentor?.email || "Mentor";
                const initial = mentorName.charAt(0).toUpperCase();
                const isSelected = selectedRequest?._id === req._id;
                const sc = statusConfig(req);

                return (
                  <Paper
                    key={req._id}
                    elevation={0}
                    onClick={() => {
                      setSelectedRequest(req);
                      if (isMobile) setDrawerOpen(true);
                    }}
                    sx={{
                      p: { xs: 1.5, sm: 2 }, mb: 1.25,
                      borderRadius: 2.5, cursor: "pointer",
                      transition: "all 0.2s ease",
                      display: "flex", alignItems: "center",
                      justifyContent: "space-between", gap: 1.5,
                      border: `1.5px solid ${isSelected ? C.primary : C.borderSoft}`,
                      bgcolor: isSelected ? C.primarySofter : C.paper,
                      width: "100%", boxSizing: "border-box",
                      "&:hover": {
                        bgcolor: C.primarySofter,
                        borderColor: C.primary,
                        transform: "translateX(2px)",
                        boxShadow: "0 4px 12px rgba(10,46,138,0.08)",
                      },
                    }}
                  >
                    <Stack direction="row" alignItems="center" spacing={{ xs: 1, sm: 1.75 }} flex={1} minWidth={0}>
                      <Avatar sx={{
                        width: { xs: 42, sm: 52 }, height: { xs: 42, sm: 52 },
                        background: `linear-gradient(135deg, ${C.primary}, ${C.primaryLight})`,
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: { xs: "1rem", sm: "1.2rem" },
                        boxShadow: `0 4px 10px ${C.primary}25`,
                        flexShrink: 0,
                      }}>
                        {initial}
                      </Avatar>
                      <Box flex={1} minWidth={0}>
                        <Typography fontWeight={700} sx={{
                          color: C.textPrimary, mb: 0.5,
                          fontSize: { xs: 12.5, sm: 14 },
                          overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                        }}>
                          {req.goal}
                        </Typography>
                        <Typography variant="body2" sx={{
                          color: C.textSecondary, mb: 0.5,
                          fontSize: { xs: 11, sm: 12 },
                          overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                        }}>
                          To: <Box component="span" sx={{ fontWeight: 700, color: C.textPrimary }}>{mentorName}</Box>
                        </Typography>
                        <Chip
                          icon={sc.icon}
                          label={sc.label}
                          size="small"
                          sx={{
                            bgcolor: sc.bg, color: sc.fg,
                            fontWeight: 700, fontSize: "0.68rem",
                            height: 20,
                            "& .MuiChip-icon": { color: sc.fg },
                            "& .MuiChip-label": { px: 0.75 },
                          }}
                        />
                      </Box>
                    </Stack>

                    <Tooltip title="Cancel Request">
                      <IconButton
                        size="small"
                        onClick={(e) => { e.stopPropagation(); handleCancelRequest(req._id); }}
                        sx={{
                          color: C.error,
                          bgcolor: C.errorSoft,
                          flexShrink: 0,
                          "&:hover": { bgcolor: alpha(C.error, 0.2) },
                        }}
                      >
                        <Close fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Paper>
                );
              })}

              {/* Pagination */}
              {totalPages > 1 && (
                <Box
                  display="flex" justifyContent="space-between" alignItems="center"
                  mt={2.5} pt={2.5}
                  sx={{ borderTop: `1px solid ${C.borderSoft}` }}
                >
                  <Button
                    startIcon={<ArrowBack />}
                    onClick={handlePrev}
                    disabled={currentPage === 1}
                    sx={{
                      textTransform: "none", fontWeight: 600,
                      fontSize: { xs: 12, sm: 13 },
                      color: currentPage === 1 ? C.textMuted : C.primary,
                      "&:hover": { bgcolor: C.primarySoft },
                    }}
                  >
                    Prev
                  </Button>
                  <Typography variant="body2" sx={{
                    fontWeight: 600, color: C.textSecondary,
                    fontSize: { xs: 11, sm: 12 },
                  }}>
                    {currentPage} / {totalPages}
                  </Typography>
                  <Button
                    endIcon={<ArrowForward />}
                    onClick={handleNext}
                    disabled={currentPage === totalPages}
                    sx={{
                      textTransform: "none", fontWeight: 600,
                      fontSize: { xs: 12, sm: 13 },
                      color: currentPage === totalPages ? C.textMuted : C.primary,
                      "&:hover": { bgcolor: C.primarySoft },
                    }}
                  >
                    Next
                  </Button>
                </Box>
              )}
            </Paper>

            {/* ── Right: Detail panel — desktop only ───────────── */}
            {!isMobile && (
              <Card
                elevation={0}
                sx={{
                  position: "relative",
                  flex: 1, p: { sm: 3, md: 4 },
                  borderRadius: 3,
                  minHeight: { lg: "80vh" },
                  bgcolor: C.paper,
                  border: `1px solid ${C.border}`,
                  boxShadow: "0 2px 12px rgba(13,17,23,0.04)",
                  boxSizing: "border-box",
                  overflow: "auto",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0, left: 0, right: 0,
                    height: "3px",
                    background: `linear-gradient(90deg, ${C.secondary}, ${C.secondary}88)`,
                  },
                }}
              >
                <DetailContent />
              </Card>
            )}
          </Box>
        )}
      </Box>

      {/* ── Mobile: detail panel in bottom drawer ──────────────── */}
      {isMobile && (
        <Drawer
          anchor="bottom"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          PaperProps={{
            sx: {
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              maxHeight: "88vh",
              overflowY: "auto",
              px: "16px",
              pt: "20px",
              pb: "32px",
            },
          }}
        >
          {/* Drag handle */}
          <Box sx={{ width: 40, height: 4, bgcolor: C.borderSoft, borderRadius: 2, mx: "auto", mb: 2.5 }} />
          <DetailContent />
        </Drawer>
      )}

      <Footer />
    </Box>
  );
};

export default PendingRequests;